import { Link } from 'react-router-dom'
import { SITE } from '@/data/site'

interface LogoProps {
  /** 是否显示文字 */
  withText?: boolean
}

export function Logo({ withText = true }: LogoProps) {
  return (
    <Link to="/" className="logo" aria-label={`${SITE.name} 首页`}>
      <span className="logo-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" width="26" height="26" fill="none">
          <defs>
            <linearGradient id="logo-grad" x1="0" y1="0" x2="32" y2="32">
              <stop offset="0%" stopColor="#6c63ff" />
              <stop offset="100%" stopColor="#3ecfcf" />
            </linearGradient>
          </defs>
          <rect width="32" height="32" rx="8" fill="url(#logo-grad)" opacity="0.16" />
          <path
            d="M9 22 16 9l7 13"
            stroke="url(#logo-grad)"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M13 18h6" stroke="url(#logo-grad)" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
      </span>
      {withText && (
        <span className="logo-text">
          <span className="logo-name">{SITE.name}</span>
          <span className="logo-en">{SITE.nameEn}</span>
        </span>
      )}
    </Link>
  )
}
